var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#303030",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "16/block",
    clipPath: "url(#clip0_729_1186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.04222 2.87448C5.94075 2.35465 6.96077 2.08169 7.99882 2.08329L7.99998 2.08329C9.36354 2.08329 10.6193 2.54451 11.6199 3.31945L3.31947 11.6199C2.54453 10.6193 2.08331 9.36352 2.08331 7.99996C2.08331 6.92121 2.37149 5.91108 2.87439 5.04238C3.08192 4.68391 2.95955 4.22507 2.60107 4.01754C2.2426 3.81002 1.78376 3.93239 1.57623 4.29086C0.944467 5.38216 0.583313 6.6507 0.583313 7.99996C0.583313 12.0962 3.90377 15.4166 7.99998 15.4166C12.0962 15.4166 15.4166 12.0962 15.4166 7.99996C15.4166 3.90413 12.0968 0.583916 8.00114 0.583291C6.69854 0.581284 5.41857 0.923802 4.29107 1.57611C3.93253 1.78353 3.81004 2.24233 4.01746 2.60087C4.22489 2.9594 4.68369 3.0819 5.04222 2.87448ZM4.38014 12.6805C5.38068 13.4554 6.63645 13.9166 7.99998 13.9166C11.2678 13.9166 13.9166 11.2677 13.9166 7.99996C13.9166 6.63643 13.4555 5.38066 12.6805 4.38012L4.38014 12.6805Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_729_1186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.d9256c9a.svg";
export { ForwardRef as ReactComponent };